export default __webpack_public_path__ + "static/media/lumenpulse.b91df8ca.png";